export class ConfigurationService {
  async loadSensefuel(sensefuelId: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (!sensefuelId) {
        throw new Error('No sensefuelId provided.');
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://tag.search.sensefuel.live/tag/${sensefuelId}/tagp.js`;
      script.onload = () => resolve(true);
      document.head.insertBefore(script, document.head.firstChild);
    });
  }
}
